import { render, staticRenderFns } from "./AutoEnrollmentInitialPercentInput.vue?vue&type=template&id=12af9b6a&"
import script from "./AutoEnrollmentInitialPercentInput.vue?vue&type=script&lang=js&"
export * from "./AutoEnrollmentInitialPercentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports